export default '/api';
